module.exports = __webpack_public_path__ + "static/media/settings.e5ed63fa.svg";